import LiveStatsCommissionPerMonthList from './List';

const LiveStatsCommissionPerMonth = {
  LiveStatsCommissionPerMonthList, 
};

export default LiveStatsCommissionPerMonth;